var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._v("\n    Guess the payment card expiration by attempting up to 3 guesses at a new expiration date (based on an analysis of likely variations).\n")])}
var staticRenderFns = []

export { render, staticRenderFns }